module.exports = __webpack_public_path__ + "img/dotcontainer1-min.f5b03662.jpg";